// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  It applies to page with side bar.
  Example: systemParams -> systemParams.component.scss
*/
/*
  It applies to the title (header) of page content body.
*/
/*
  It describes common behavior on mouse hover.
*/
/*
  It describes light shadow for any page block.
*/
/*
  It applies to entity block like project, facility which has own title, edit button and body.
*/
/*
  It applies together with entity-card mixin, which has been described above
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
:host {
  display: flex;
  flex: 1;
}

.facilities-wrapper {
  font-weight: normal;
  font-size: 16px;
  font-family: GothamBold, sans-serif;
  background-color: #f7f7f7;
  padding: 10px;
  flex: 1;
  padding: 20px;
}

.facilities-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.facility-systems-list-wrapper {
  justify-content: left;
  flex: 3;
  background-color: #fff;
  min-width: 0;
}

.facilities-placeholder {
  background: #fff;
  padding: 20px;
  flex: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
